import React, { useState } from 'react';
import { Button } from '../ui/button';
import { ScanBarcode } from 'lucide-react';
import BarcodeScanner from './BarcodeScanner';

/** Drop-in "Scan Barcode" button that opens the shared scanner. */
const ScanButton = ({ mode = 'scan', context = {}, label = 'Scan Barcode', onDone, testId = 'scan-barcode-btn', variant, className }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        data-testid={testId}
        onClick={() => setOpen(true)}
        variant={variant}
        className={className || 'bg-[#D4AF37] text-[#0A0A0A] hover:bg-[#F3E5AB]'}
      >
        <ScanBarcode className="w-4 h-4 mr-2" /> {label}
      </Button>
      <BarcodeScanner open={open} onClose={() => setOpen(false)} mode={mode} context={context} onDone={(d) => { onDone?.(d); }} />
    </>
  );
};

export default ScanButton;
